import { IMAGES } from 'config/images';
import { AppLocale, getAppLocaleValue, getTrans } from 'modules/i18n';
import { InstallationImages } from './types';

export const ZENJOB_LOGO_ALT_TEXT = 'Zenjob Pro Logo Purple';

export const androidInstallationInstructions = (): string[] => [
  getTrans('appInstallPage.instructions.android.body1'),
  getTrans('appInstallPage.instructions.android.body2'),
  getTrans('appInstallPage.instructions.android.body3'),
  getTrans('appInstallPage.instructions.android.body4')
];

export const iosInstallationInstructions = (): string[] => [
  getTrans('appInstallPage.instructions.ios.body1'),
  getTrans('appInstallPage.instructions.ios.body2'),
  getTrans('appInstallPage.instructions.ios.body3'),
  getTrans('appInstallPage.instructions.ios.body4')
];

export const androidInstallationImages: InstallationImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    IMAGES.android1.en,
    IMAGES.android2.en,
    IMAGES.android3.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    IMAGES.android1.de,
    IMAGES.android2.de,
    IMAGES.android3.de
  ]
};

export const iosInstallationImages: InstallationImages = {
  [getAppLocaleValue[AppLocale.en_US]]: [
    IMAGES.ios1.en,
    IMAGES.ios2.en,
    IMAGES.ios3.en
  ],
  [getAppLocaleValue[AppLocale.de_DE]]: [
    IMAGES.ios1.de,
    IMAGES.ios2.de,
    IMAGES.ios3.de
  ]
};
